import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import PublicLayout from "@/components/PublicLayout";
import Analytics from "@/components/Analytics";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import ComprarPage from "@/pages/ComprarPage";
import VenderPage from "@/pages/VenderPage";
import ZonasPage from "@/pages/ZonasPage";
import ZonaDetailPage from "@/pages/ZonaDetailPage";
import ImoveisPage from "@/pages/ImoveisPage";
import ImovelDetailPage from "@/pages/ImovelDetailPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import SobrePage from "@/pages/SobrePage";
import ContactoPage from "@/pages/ContactoPage";
import AvaliacaoPage from "@/pages/AvaliacaoPage";
import FavoritesPage from "@/pages/FavoritesPage";
import SharedFavoritesPage from "@/pages/SharedFavoritesPage";
import ComparePage from "@/pages/ComparePage";
import ThankYouPage from "@/pages/ThankYouPage";
import ComparadorPage from "@/pages/ComparadorPage";
import TermosPage from "@/pages/TermosPage";
import PoliticaPrivacidadePage from "@/pages/PoliticaPrivacidadePage";
import LoginPage from "@/pages/LoginPage";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminZones from "@/pages/admin/AdminZones";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminSettings from "@/pages/admin/AdminSettings";

const wrap = (Page) => (
  <PublicLayout>
    <Page />
  </PublicLayout>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <Routes>
              <Route path="/" element={wrap(HomePage)} />
              <Route path="/comprar-casa-no-porto" element={wrap(ComprarPage)} />
              <Route path="/vender-casa-no-porto" element={wrap(VenderPage)} />
              <Route path="/zonas" element={wrap(ZonasPage)} />
              <Route path="/zonas/:slug" element={wrap(ZonaDetailPage)} />
              <Route path="/imoveis" element={wrap(ImoveisPage)} />
              <Route path="/imoveis/:slug" element={wrap(ImovelDetailPage)} />
              <Route path="/blog" element={wrap(BlogPage)} />
              <Route path="/blog/:slug" element={wrap(BlogPostPage)} />
              <Route path="/sobre" element={wrap(SobrePage)} />
              <Route path="/contacto" element={wrap(ContactoPage)} />
              <Route path="/avaliacao-gratuita" element={wrap(AvaliacaoPage)} />
              <Route path="/favoritos" element={wrap(FavoritesPage)} />
              <Route path="/favoritos/partilha/:shareId" element={wrap(SharedFavoritesPage)} />
              <Route path="/comparar" element={wrap(ComparePage)} />
              <Route path="/obrigado" element={wrap(ThankYouPage)} />
              <Route path="/comparador-precos-porto" element={wrap(ComparadorPage)} />
              <Route path="/termos" element={wrap(TermosPage)} />
              <Route path="/politica-de-privacidade" element={wrap(PoliticaPrivacidadePage)} />

              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/imoveis" element={<AdminProperties />} />
              <Route path="/admin/zonas" element={<AdminZones />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/testemunhos" element={<AdminTestimonials />} />
              <Route path="/admin/faqs" element={<AdminFaqs />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/newsletter" element={<AdminNewsletter />} />
              <Route path="/admin/definicoes" element={<AdminSettings />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
        </FavoritesProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
